export default {"src":"https://search.testwiggot.com/_next/static/media/yellow-thingy.dc8e321e.svg","height":61,"width":61,"blurWidth":0,"blurHeight":0};